import { FullHouseLandscapeProperties } from "../landscape/FullHouseLandscapeProperties";
/**
 * FullHousePortraitProperties.ts
 */
export class FullHousePortraitProperties extends FullHouseLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.scale.set(1);
        this.position.set(512, 795);
    }
}
